import { BaseApi } from 'Core/api/BaseApi'
import { TypesHelper } from 'SRC/utils'

export class Api extends BaseApi {
  getNotifications = async ({ userId, token }) => {
    const defaultResult = { notifications: [] }

    try {
      const { body } = await Api.post('/notifications/list', { userId, token })

      if (body.error) {
        return defaultResult
      }

      if (Array.isArray(body.notifications)) {
        return {
          notifications: body.notifications
        }
      }

      return defaultResult
    } catch (e) {
      return defaultResult
    }
  }

  readNotification = async ({ userId, token, notification }) => {
    const defaultResult = { notifications: [] }

    try {
      const { body } = await Api.post('/notifications/read', { userId, token, notification })

      if (body.error) return defaultResult

      if (Array.isArray(body.notifications)) {
        return {
          notifications: body.notifications
        }
      }

      return defaultResult
    } catch (e) {
      return defaultResult
    }
  }

  unreadNotification = async ({ userId, token, notification }) => {
    const defaultResult = { notifications: [] }

    try {
      const { body } = await Api.post('/notifications/unread', { userId, token, notification })

      if (body.error) return defaultResult

      if (Array.isArray(body.notifications)) {
        return {
          notifications: body.notifications
        }
      }

      return defaultResult
    } catch (e) {
      return defaultResult
    }
  }
}